import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-lg text-background-50">
                <i className="ri-movie-2-line" />
              </span>
              <span className="font-heading text-lg font-black">河马AV</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              聚焦最新影视资源和行业动态，提供丰富的影视内容介绍与资讯服务，帮助每一位影迷找到想看的下一部作品。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-widest text-primary-100">影视分类</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-primary-200 transition-colors hover:text-accent-400"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-widest text-primary-100">站内导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-primary-200 transition-colors hover:text-accent-400">首页</Link></li>
              <li><Link to="/news" className="text-sm text-primary-200 transition-colors hover:text-accent-400">资讯动态</Link></li>
              <li><Link to="/search" className="text-sm text-primary-200 transition-colors hover:text-accent-400">搜索</Link></li>
              <li><Link to="/about" className="text-sm text-primary-200 transition-colors hover:text-accent-400">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-widest text-primary-100">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-primary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                contact@hema-av.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" />
                内容更新：每日 09:00 / 18:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-information-line text-accent-400" />
                本站内容均为介绍展示
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 河马AV · 专业影视内容平台 · 内容与数据均为演示示例</p>
          <p className="flex flex-wrap items-center gap-4">
            <span>网站介绍</span>
            <span>使用须知</span>
            <span>内容声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}